// Устанавливает новое значение window.location.href без перезагрузки страницы
function setHrefValue(url) {
	window.history.pushState({path : url}, '', url);
}


// Устанавливает новое значение pathname внутри window.location без перезагрузки страницы
// Значение pathname передается со слешами в начале и в конце, например: /path/name/
function setPathValue(pathname, hasSearch, hasHash) {
	if (history.pushState) {
	    var url = window.location.protocol + "//" + window.location.host + pathname;

	    if (hasSearch) url += window.location.search;
	    if (hasHash) url =+ window.location.hash;

	    window.history.pushState({path : url}, '', url);
	}
	else return false;
}


// Возвращает массив переменных из Query String
function getQueryStringVars(url) {
    var varsArray = {},
    	parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
        	varsArray[key] = value;
    	});

    return varsArray;
}


// Получает значение указанного параметра из Query String
function getQueryStringVarValue(varName) {
	var queryStr = unescape(window.location.search) + '&',
		regex = new RegExp('.*?[&\\?]' + varName + '=(.*?)&.*');

	val = queryStr.replace(regex, "$1");
	return val == queryStr ? false : val;
}


// Очищает Query String
function clearQueryString() {
	if (history.pushState) {
	    var url = window.location.protocol + "//" + window.location.host + window.location.pathname;

	    window.history.pushState({path : url}, '', url);
	}
	else return false;
}


// Устанавливает значение для заданного параметра в Query String без перезагрузки страницы
function setQueryStringVarValue(varName, value) {
	if (history.pushState) {
	    var url = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + varName + '=' + value;
	    
	    window.history.pushState({path : url}, '', url);
	}
	else return false;
}